<template>
  <div>
    <ProductItemPlus
      :product="product"
      v-if="product.productType === 'PLUS' || product.productType === 'PRO'"
      :accommodationName="accommodationName"
    />
    <ProductItemRateConnect :product="product" v-if="product.productType === 'RATE_CONNECT'" />
  </div>
</template>
<script setup>
import ProductItemPlus from '@/components/billing/premiumProducts/ProductItemPlus.vue'
import ProductItemRateConnect from '@/components/billing/premiumProducts/ProductItemRateConnect.vue'

defineProps({
  product: Object,
  accommodationName: String,
})
</script>
